export default __webpack_public_path__ + "static/media/acmvit.6870c3f3.png";